import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, startWith } from 'rxjs/operators';

import { PerfilesService } from '../../../services/perfiles/perfiles.service';
import { PreviousRouteService } from '@services/shared/previous-route.service';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { SignoSeguridadService } from '@services/seguridad/signo-seguridad.service';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

interface AdminItem {
    title: string;
    desc: string;
    icon: string; // clase FA
    color: string; // color del ícono
    route: string; // routerLink
    terms?: string; // precálculo para búsquedas
}

@Component({
    selector: 'app-entidades-administracion',
    templateUrl: './entidades-administracion.component.html',
    styleUrls: ['./entidades-administracion.component.scss'],
})
export class EntidadesAdministracionComponent implements OnInit, OnDestroy {
    routes: { url: string; label: string }[] = [{ url: '/', label: 'Inicio' }];

    // 🔎 Buscador
    searchCtrl = new FormControl('');

    // 📦 Ítems del panel
    items: AdminItem[] = [
        {
            title: 'Centros Médicos',
            desc: 'Acceda al listado de Centros Médicos del sistema',
            icon: 'fas fa-clinic-medical',
            color: '#0d6efd',
            route: '/centros-medicos-listado',
        },
        {
            title: 'Rubros',
            desc: 'Acceda al listado de Rubros del sistema',
            icon: 'fas fa-hospital',
            color: '#6c757d',
            route: '/rubros-listado',
        },
        {
            title: 'Especialidades',
            desc: 'Acceda al listado de Especialidades del sistema',
            icon: 'fas fa-hospital-user',
            color: '#198754',
            route: '/especialidades-listado',
        },
        {
            title: 'Zonas',
            desc: 'Acceda al listado de Zonas del sistema',
            icon: 'fas fa-map-pin',
            color: '#dc3545',
            route: '/zonas-listado',
        },
        {
            title: 'Localidades',
            desc: 'Acceda al listado de Localidades del sistema',
            icon: 'fas fa-map-marker-alt',
            color: '#ffc107',
            route: '/localidades-listado',
        },
        // {
        //     title: 'Centros Propios',
        //     desc: 'Acceda al listado de Centros Propios del sistema',
        //     icon: 'fas fa-hospital-alt',
        //     color: '#0dcaf0',
        //     route: '/centros-propios-listado',
        // },
        // {
        //     title: 'Centros Propios Doctores',
        //     desc: 'Doctores de centros propios',
        //     icon: 'fas fa-user-md',
        //     color: '#d35400',
        //     route: '/doctores-listado',
        // },
        // {
        //     title: 'Centros Propios Especialidades',
        //     desc: 'Especialidades de centros propios',
        //     icon: 'fas fa-briefcase-medical',
        //     color: '#212529',
        //     route: '/centros-propios-especialidades-listado',
        // },
        {
            title: 'Afiliados',
            desc: 'Acceda al listado de Afiliados del sistema',
            icon: 'fas fa-users',
            color: '#34495e',
            route: '/afiliados-listado',
        },
        {
            title: 'Sedes',
            desc: 'Acceda al listado de Sedes del sistema',
            icon: 'fas fa-handshake',
            color: '#8e44ad',
            route: '/sedes-listado',
        },
        {
            title: 'Autorizaciones',
            desc: 'Acceda al listado de Autorizaciones del sistema',
            icon: 'fas fa-calendar-check',
            color: '#d980fa',
            route: '/autorizaciones-listado',
        },
        {
            title: 'Listado de Inscripciones',
            desc: 'Acceda al listado de las inscripciones de la Obra Social',
            icon: 'fas fa-file-alt',
            color: '#55b03e',
            route: '/listado-inscripciones',
        },
        {
            title: 'Empresas',
            desc: 'Acceda al listado de Empresas del sistema',
            icon: 'fas fa-building',
            color: '#1abc9c',
            route: '/empresas-listado',
        },
        {
            title: 'Planes',
            desc: 'Acceda al listado de Planes del sistema',
            icon: 'far fa-credit-card',
            color: '#c0392b',
            route: '/planes-listado',
        },
        {
            title: 'Órdenes Médicas',
            desc: 'Configurar tipos de órdenes',
            icon: 'fas fa-file-medical',
            color: '#27ae60',
            route: '/tipo-orden-consulta',
        },
        {
            title: 'Padrones Médicos',
            desc: 'Importación y gestión de centros médicos desde padrones',
            icon: 'fas fa-file-import',
            color: '#4b7bec',
            route: '/padrones-administracion',
        },
        {
            title: 'Seguridad',
            desc: 'Gestione usuarios, roles y permisos del sistema',
            icon: 'fas fa-user-shield',
            color: '#8e44ad',
            route: '/menu-seguridad',
        },
        {
            title: 'Auditoría',
            desc: 'Trazabilidad de acciones del sistema',
            icon: 'fas fa-users-cog',
            color: '#e67e22',
            route: '/menu-auditoria',
        },
        {
            title: 'Push Notificaciones',
            desc: 'Administración de notificaciones push del sistema',
            icon: 'fas fa-bell',
            color: '#580f2e',
            route: '/push-administracion',
        },
        {
            title: 'Estadísticas de Sistema',
            desc: 'Métricas e indicadores del sistema',
            icon: 'fas fa-chart-pie',
            color: '#0d6efd',
            route: '/estadisticas-sistema',
        },
    ].map((x) => ({ ...x, terms: norm(`${x.title} ${x.desc}`) }));

    filtered: AdminItem[] = [];

    constructor(
        private router: Router,
        private perfilesService: PerfilesService,
        private previousRouteService: PreviousRouteService,
        private signoAuditoriaService: SignoAuditoriaService,
        private signoSeguridadService: SignoSeguridadService,
        private modalCustom: PopUpModalCustomService,
    ) {}

    ngOnDestroy(): void {
        this.modalCustom.cerrar();
    }

    ngOnInit(): void {
        // auth/permisos
        this.perfilesService.allowedByUserLogon(this.router.url);

        // migas
        this.previousRouteService.getRoutes().subscribe((routes) => {
            this.routes = routes;
        });

        // listado inicial
        this.filtered = [...this.items];

        // búsqueda reactiva
        this.searchCtrl.valueChanges
            .pipe(startWith(''), debounceTime(120))
            .subscribe((q) => {
                const query = norm(q || '');
                if (!query) {
                    this.filtered = this.items;
                    return;
                }
                this.filtered = this.items
                    .map((item) => ({ item, score: score(query, item.terms!) }))
                    .filter((x) => x.score > 0)
                    .sort((a, b) => b.score - a.score)
                    .map((x) => x.item);
            });

        // modal de acceso denegado (auditoría o seguridad)
        if (this.signoAuditoriaService.accesoDenegado || this.signoSeguridadService.accesoDenegado) {
            this.modalCustom.abrirPopup({
                titulo: 'Acceso restringido',
                mensaje: 'No contás con los permisos necesarios para acceder a esta sección.',
                tipo: 'warning',
            });

            this.signoAuditoriaService.setAccesoDenegado(false);
            this.signoSeguridadService.setAccesoDenegado(false);
        }
    }

    // 👇 al final de la clase
    trackByTitle(index: number, item: AdminItem): string {
        return item.title; // o item.route si es único
    }
}

/* ===== Utils de búsqueda (norm + score + levenshtein) ===== */

function norm(s: string): string {
    return (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim();
}

function score(q: string, text: string): number {
    if (!q || !text) return 0;

    // Inclusión directa
    if (text.includes(q)) return 100 + q.length;

    // Prefijo de palabra
    const anyPrefix = text.split(/\s+/).some((w) => w.startsWith(q));
    if (anyPrefix) return 80 + Math.min(q.length, 10);

    // Levenshtein acotado
    if (q.length >= 3) {
        const win = Math.min(Math.max(q.length + 6, 12), 28);
        let best = Infinity;
        for (let i = 0; i <= text.length - q.length; i++) {
            const slice = text.slice(i, i + win);
            const d = lev(q, slice);
            if (d < best) best = d;
            if (best === 0) break;
        }
        const tol = q.length <= 4 ? 1 : q.length <= 7 ? 2 : 3;
        if (best <= tol) return 60 - best * 5 + q.length;
    }

    return 0;
}

function lev(a: string, b: string): number {
    const m = a.length,
        n = b.length;
    if (!m) return n;
    if (!n) return m;
    const dp = new Array(n + 1);
    for (let j = 0; j <= n; j++) dp[j] = j;
    for (let i = 1; i <= m; i++) {
        let prev = dp[0];
        dp[0] = i;
        for (let j = 1; j <= n; j++) {
            const temp = dp[j];
            dp[j] = Math.min(
                dp[j] + 1,
                dp[j - 1] + 1,
                prev + (a[i - 1] === b[j - 1] ? 0 : 1),
            );
            prev = temp;
        }
    }
    return dp[n];
}
